.modalBackdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modalContent {
  background-color: var(--color-bg-primary);
  padding: 20px;
  border-radius: 8px;
  max-width: 90vw;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  position: relative;
  max-height: 95vh;
}

.closeButton {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
}
